import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Project } from '@shared/interfaces/project.interface';

interface DeleteProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectToDelete: Project | null;
  onConfirm: (project: Project) => void;
}

const DeleteProjectModal: React.FC<DeleteProjectModalProps> = ({
  isOpen,
  onClose,
  projectToDelete,
  onConfirm
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Project</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this project? This will hide it from view but allow recovery later.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            Project: <strong>{projectToDelete?.client_org || projectToDelete?.name}</strong>
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            This action will mark the project as deleted. Only Super Admins will be able to view or restore it.
          </p>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              if (projectToDelete) {
                onConfirm(projectToDelete);
                onClose();
              }
            }}
          >
            Delete Project
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteProjectModal;